export default __webpack_public_path__ + "static/media/success.39ee2021.webp";